import type { ApiTypes } from 'shared/api/services/types';
import { getAccessToken } from 'shared/lib/sessionTokenAccessor';

const getHeaders = async () => {
  const accessToken = await getAccessToken();

  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
};

class ApiMethods {
  static async apiRequest(
    method: string,
    address: string,
    body?: object,
    apiType: ApiTypes = 'api'
  ) {
    const api =
      apiType === 'notifications'
        ? process.env.NOTIFICATIONS_API
        : process.env.API_URL;

    const url = api + address;

    // console.log('fetching url: ', url);

    const headers = await getHeaders();

    const options: RequestInit = {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    };

    return fetch(url, options);
  }

  static get(address: string, apiType?: ApiTypes) {
    return this.apiRequest('GET', address, undefined, apiType);
  }

  static post(address: string, data: any, apiType?: ApiTypes) {
    return this.apiRequest('POST', address, data, apiType);
  }

  static put(address: string, data: any, apiType?: ApiTypes) {
    return this.apiRequest('PUT', address, data, apiType);
  }

  static delete(address: string, apiType?: ApiTypes) {
    return this.apiRequest('DELETE', address, undefined, apiType);
  }

  static patch(address: string, data: any, apiType?: ApiTypes) {
    return this.apiRequest('PATCH', address, data, apiType);
  }
}

export default ApiMethods;
